"use strict";

require("core-js/modules/es.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _auth = require("@nextcloud/auth");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var client = _axios["default"].create({
  headers: {
    requesttoken: (0, _auth.getRequestToken)()
  }
});

(0, _auth.onRequestTokenUpdate)(function (token) {
  return client.defaults.headers.requesttoken = token;
});
var _default = client;
exports["default"] = _default;
//# sourceMappingURL=client.js.map